import messages from "./messages";
import React from "react";
import { colors } from "../../../shared/colors";

export default function RequiredInfo({ className, mode = null }){
    const {id, defaultMessage: text} = messages;

    if (mode === 'asterisk') {
        return <span style={{color: colors.magellanRed}}>* </span>;
    }

    return  <div className={className} id={id} data-testid={id}>
        <div><span style={{color: colors.magellanRed}}>*</span>{text}</div>
    </div>

}